import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

import {
  findSearchRoot,
  isSearchForm,
  isSearchSubmitControl,
  trimInputElement,
  trimSearchInputsIn,
} from 'app/_utils/trim-search';

/**
 * Strips leading/trailing spaces from search fields when the user submits
 * (form submit, Enter, or a Search button / search-icon click) — not while typing.
 */
@Directive({
  selector: 'form, button, a[bkButton], .input-group-text, input[name="search"], input[name="query"], input[placeholder^="Search"]',
})
export class TrimSearchDirective implements OnInit, OnDestroy {
  private readonly el: HTMLElement;
  private readonly onSubmit = () => this.trimForm();
  private readonly onClick = () => this.trimOnSearchClick();
  private readonly onEnter = (event: KeyboardEvent) => {
    if (event.key === 'Enter') this.trimInput();
  };

  constructor(elRef: ElementRef<HTMLElement>) {
    this.el = elRef.nativeElement;
  }

  ngOnInit(): void {
    const tag = this.el.tagName;
    if (tag === 'FORM') {
      this.el.addEventListener('submit', this.onSubmit, true);
      return;
    }
    if (tag === 'INPUT') {
      this.el.addEventListener('keydown', this.onEnter, true);
      return;
    }
    this.el.addEventListener('click', this.onClick, true);
  }

  ngOnDestroy(): void {
    this.el.removeEventListener('submit', this.onSubmit, true);
    this.el.removeEventListener('click', this.onClick, true);
    this.el.removeEventListener('keydown', this.onEnter, true);
  }

  private trimForm(): void {
    if (isSearchForm(this.el)) trimSearchInputsIn(this.el);
  }

  private trimOnSearchClick(): void {
    if (!isSearchSubmitControl(this.el)) return;
    trimSearchInputsIn(findSearchRoot(this.el));
  }

  private trimInput(): void {
    if (this.el instanceof HTMLInputElement) trimInputElement(this.el);
  }
}
